import React from "react";
import { useState } from 'react';
import axios from 'axios';
import { apiUrl } from "../../config/Config";
import placeholderuser from '../../assets/images/userplaceholder.webp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from 'react-router-dom';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
const Newuser = () => {
const [firstname, setfirstname] = useState('');
const [lastname, setlastname] = useState('');
const [email, setemail] = useState('');
const [number, setnumber] = useState('');
const [joindate, setjoindate] = useState('');
const [role, setrole] = useState('');
const [password, setpassword] = useState('');
const [retypepassword, setretypepassword] = useState('');
    const [showloding, setshowloding] = useState(false);
  const navigate = useNavigate();
    const userpressed = async() => {
        // navigate('/customer/home');
        
          setshowloding(true);
          var data = {
              'firstname' : firstname,
              'lastname': lastname,
             'email': email,
             'number': number, 
             'joindate': joindate,
             'role': role,
             'password': password,
             'retypepassword': retypepassword,

          }

          console.log(data)
        //   const headers = {
        //       headers: {
        //           'Content-Type': 'application/json',
        //           'Access-Control-Allow-Origin': '*'
        //       }
        //   }
        // let resp = await axios.post(apiUrl + 'adminlogin', data, headers).then((res) => {
        //       if(res.data.status == 'success') {
        //         // dispatch({ type: "userdata", payload: res.data.data })
        //         navigate('/admin/dashboard');
        //       } else {
        //         alert(res.data.message);
        //       }
        //   } ).catch((err) => {
        //       alert(err.message)
        //   })
          setshowloding(false);
      
      }  
  

   /*============== */ 
    return (
        <div className="newuser-container">
            <p className="newuser-title">Add Internal User</p>
            <div className="newuser-form-box">
              
  <div className="newuser-avatar-section">
                            <div className="newuser-avatar">
                                <span className="newuser-avatar-icon"><img src={placeholderuser} className="placeholderuser" /></span>
                                <button className="newuser-edit-icon"><FontAwesomeIcon icon={faPencilAlt} /></button>
                            </div>
                        </div>
                <div className="newuser-form">
                <div className="newuser-field">
                            <label>First Name</label>
                            <input type="text" placeholder="Enter Firstname"
                            value={firstname}
                            onChange={(e) => setfirstname(e.target.value)}
                            />
                        </div>
                        <div className="newuser-field">
                            <label>Last Name</label>
                            <input type="text" placeholder="Enter Lastname" value={lastname} 
                            onChange={(e) => setlastname(e.target.value)}
                            />
                        </div>
                        <div className="newuser-field">
                            <label>Email</label>
                            <input type="email" placeholder="Enter Email"  value={email} 
                            onChange={(e) => setemail(e.target.value)}
                            
                            />
                        </div>
                        <div className="newuser-field">
                            <label>Mobile Number</label>
                            <input type="tel" placeholder="Enter Mobile Number" value={number}
                            onChange={(e) => setnumber(e.target.value)}
                            />
                        </div>
                    
                </div>
                <div className="newuser-form">
                <div className="newuser-field">
                            <label>Joining Date</label>
                            <input type="date"  value={joindate}
                             onChange={(e) => setjoindate(e.target.value)}
                            
                            
                            
                            />
                        </div>
                        <div className="newuser-field">
                            <label>Role</label>
                            <select value={role}    onChange={(e) => setrole(e.target.value)}>
                                <option value="">Select Role</option>
                                <option value="admin">Admin</option>
                                <option value="user">User</option>
                            </select>
                        </div>
                        <div className="newuser-field">
                            <label>Password</label>
                            <input type="password" placeholder="Enter Password"  value={password}     onChange={(e) => setpassword(e.target.value)}/>
                        </div>
                        <div className="newuser-field">
                            <label>Re-type Password</label>
                            <input type="password" placeholder="Enter Re-type Password"  value={retypepassword}      onChange={(e) => setretypepassword(e.target.value)}/>
                        </div>
                        <div className='mb-2'>
                                    <button type="submit  "  onClick={() => {userpressed()}} className="btn btn-primary newuser-btn">  Save</button>
             
                                </div>
                </div>
            </div>
        </div>
    )
};
export default Newuser